import { Button } from "@/components/ui/button";
import { Bike } from "lucide-react";

export const HeroSection = () => {
  const scrollToCalculator = () => {
    const calculator = document.getElementById('calculator');
    calculator?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToGallery = () => {
    const gallery = document.getElementById('gallery');
    gallery?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Animated Background */}
      <div className="absolute inset-0 w-full h-full bg-animated-gradient" />

      {/* Animated Bike Icon */}
      <div className="absolute top-8 right-8 z-10">
        <Bike className="w-12 h-12 text-primary bike-wheel" />
      </div>

      {/* Hero Content */}
      <div className="relative z-10 text-center max-w-6xl mx-auto px-6">
        <h1 className="font-montserrat font-black text-5xl md:text-7xl lg:text-8xl mb-6">
          <span className="text-primary">Twój rower.</span><br />
          <span className="text-foreground">Twoja wizja.</span><br />
          <span className="text-secondary">Nasza misja.</span>
        </h1>
        
        <p className="text-xl md:text-2xl text-muted-foreground mb-8 font-inter max-w-3xl mx-auto">
          Wierzymy, że rower to coś więcej niż tylko środek transportu. 
          To przedłużenie Twojej osobowości i pasji.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Button 
            size="lg" 
            onClick={scrollToCalculator}
            className="text-lg px-8 py-6 interactive-scale bg-primary text-primary-foreground hover:bg-primary/90"
          >
            Oblicz cenę tuningu
          </Button>
          
          <Button 
            variant="secondary"
            size="lg" 
            onClick={scrollToGallery}
            className="text-lg px-8 py-6 interactive-scale"
          >
            Zobacz realizacje
          </Button>
        </div>
      </div>

      {/* Scrolling indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-primary rounded-full flex justify-center">
          <div className="w-1 h-3 bg-primary rounded-full mt-2 animate-bounce" />
        </div>
      </div>
    </section>
  );
};